<template>
  <el-row :gutter="activeId ? 12 : 0" class="cs">
    <el-col :span="listSpan">
      <el-card>
        <div slot="header" class="list-hdr">
          <span class="list-title">会话列表</span>
          <el-button type="primary" plain size="small" icon="el-icon-refresh" :loading="loading" @click="loadConvs">
            刷新
          </el-button>
        </div>
        <el-table
          ref="convTable"
          :data="convs"
          height="520"
          highlight-current-row
          @current-change="onPick"
          v-loading="loading"
        >
          <el-table-column prop="nickname" label="用户" width="100" />
          <el-table-column prop="lastPreview" label="最近消息" show-overflow-tooltip />
          <el-table-column label="状态" width="88">
            <template slot-scope="s">
              <el-tag v-if="s.row.completed" type="info" size="mini">已完成</el-tag>
              <el-tag v-else-if="s.row.pendingReply" type="danger" size="mini">待</el-tag>
              <el-tag v-else type="success" size="mini">已回复</el-tag>
            </template>
          </el-table-column>
        </el-table>
      </el-card>
    </el-col>
    <el-col v-if="activeId" :span="15">
      <el-card>
        <div slot="header" class="chat-hdr">
          <span class="chat-title">{{ convTitle }}</span>
          <el-button type="text" @click="clearChat">关闭对话</el-button>
        </div>
        <div class="msgs" ref="box">
          <div v-for="m in msgs" :key="m.id" :class="['msg', m.senderType === 'USER' ? 'u' : 'p']">
            <div class="meta">{{ m.senderType === 'USER' ? '用户' : '客服' }} · {{ m.createdAt | formatDateTime }}</div>
            <div class="txt">{{ m.content }}</div>
          </div>
        </div>
        <el-input type="textarea" :rows="3" v-model="reply" placeholder="输入回复内容" />
        <div class="reply-actions">
          <el-button type="primary" @click="sendReply">发送回复</el-button>
          <el-button
            type="success"
            plain
            :disabled="!activeId || (activeRow && activeRow.completed)"
            @click="completeSession"
          >完成会话</el-button>
        </div>
      </el-card>
    </el-col>
  </el-row>
</template>

<script>
import http from '../api/http';

export default {
  name: 'CsWorkbenchView',
  data() {
    return {
      loading: false,
      convs: [],
      msgs: [],
      activeId: null,
      activeRow: null,
      reply: ''
    };
  },
  computed: {
    listSpan() {
      return this.activeId ? 9 : 24;
    },
    convTitle() {
      if (!this.activeRow) return '';
      return '与「' + (this.activeRow.nickname || this.activeRow.openid) + '」的对话';
    }
  },
  mounted() {
    this.loadConvs();
  },
  methods: {
    async loadConvs() {
      this.loading = true;
      try {
        const { data } = await http.get('/admin/cs/conversations');
        this.convs = data.data || data || [];
      } catch (e) {
        this.$message.error((e && e.message) || '加载失败');
      } finally {
        this.loading = false;
      }
    },
    clearChat() {
      this.activeId = null;
      this.activeRow = null;
      this.msgs = [];
      this.reply = '';
      this.$nextTick(() => {
        const t = this.$refs.convTable;
        if (t && typeof t.setCurrentRow === 'function') {
          t.setCurrentRow();
        }
      });
    },
    async onPick(row) {
      if (!row) {
        this.clearChat();
        return;
      }
      this.activeRow = row;
      this.activeId = row.id;
      const { data } = await http.get(`/admin/cs/conversations/${row.id}/messages`);
      this.msgs = data.data || data || [];
      this.$nextTick(() => this.scrollBottom());
    },
    scrollBottom() {
      const el = this.$refs.box;
      if (el) el.scrollTop = el.scrollHeight;
    },
    async sendReply() {
      if (!this.activeId || !this.reply.trim()) return;
      try {
        await http.post(`/admin/cs/conversations/${this.activeId}/messages`, { content: this.reply.trim() });
        this.reply = '';
        this.$message.success('已发送');
        const { data } = await http.get(`/admin/cs/conversations/${this.activeId}/messages`);
        this.msgs = data.data || data || [];
        await this.loadConvs();
        this.$root.$emit('cs-unread-refresh');
        if (this.activeRow) {
          const row = this.convs.find((c) => c.id === this.activeId);
          if (row) this.activeRow = row;
        }
        this.$nextTick(() => this.scrollBottom());
      } catch (e) {
        this.$message.error((e && e.message) || '发送失败');
      }
    },
    async completeSession() {
      if (!this.activeId) return;
      try {
        await http.post(`/admin/cs/conversations/${this.activeId}/complete`);
        this.$message.success('会话已标记为已完成');
        await this.loadConvs();
        this.$root.$emit('cs-unread-refresh');
        if (this.activeRow) {
          const row = this.convs.find((c) => c.id === this.activeId);
          if (row) this.activeRow = row;
        }
      } catch (e) {
        this.$message.error((e && e.message) || '操作失败');
      }
    }
  }
};
</script>

<style scoped>
.list-hdr {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}
.list-title {
  font-weight: 600;
  color: #303133;
}
.chat-hdr {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}
.chat-title {
  font-weight: 600;
  color: #303133;
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.msgs {
  max-height: 360px;
  overflow-y: auto;
  margin-bottom: 12px;
  padding: 8px;
  background: #fafafa;
  border-radius: 4px;
}
.msg {
  margin-bottom: 10px;
}
.msg.u .txt {
  background: #ecf5ff;
}
.msg.p .txt {
  background: #f0f9eb;
}
.meta {
  font-size: 12px;
  color: #909399;
}
.txt {
  padding: 8px 10px;
  border-radius: 6px;
  white-space: pre-wrap;
  word-break: break-word;
}
.reply-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 8px;
}
</style>
